var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile',{staticClass:"list-tile-auto-height"},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"auto-height wrap"},[_c('v-layout',{attrs:{"align-center":""}},[_c('overlay-data-chip',{attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.$emit('click')}}}),_vm._v(" "),(
              _vm.showNonDefaultPrice &&
                !!_vm.overlayOptions &&
                !!_vm.overlayData &&
                _vm.overlayData.price != _vm.defaultPrice
            )?_c('span',{staticClass:"ml-2 unselectable blue--text font-weight-bold",attrs:{"title":_vm.$t('price')}},[_vm._v("\n            "+_vm._s(_vm.overlayData.price)+" "+_vm._s(_vm.currencySymbol)+"\n          ")]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/OverlayDataListTile.vue?vue&type=template&id=7c813cbb&
// module id = 2278
// module chunks = 5